module.exports = __webpack_public_path__ + "img/yz_newMonth_rz.f963af2b.png";